export function AboutBackground() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-primary-navy mb-8">
              OUR BACKGROUND
            </h2>
          </div>

          {/* Content */}
          <div className="space-y-6 text-gray-700 text-base md:text-lg leading-relaxed">
            <p>
              Founded in 2020, Centric MX has established itself as a trusted leader in general aviation maintenance, 
              providing unparalleled expertise and service to aircraft owners and operators. With half a century of 
              combined experience in the aviation industry, our team brings deep knowledge and proven reliability 
              to every project we undertake.
            </p>
            
            <p>
              At the heart of our success is our team of industry-certified maintenance technicians, who bring a 
              wealth of knowledge and hands-on experience to every aircraft they service. All our technicians hold 
              current FAA certifications and participate in ongoing professional development to stay current with 
              the latest technologies, regulations, and best practices in aviation maintenance.
            </p>
            
            <p>
              Our comprehensive range of services includes preventive maintenance, annual inspections, aircraft 
              modifications, and engine swaps, as well as troubleshooting and repairs for avionics, hydraulics, 
              and electrical systems. We are equipped to handle everything from routine maintenance to complex 
              overhauls, ensuring that every aircraft meets the highest standards of safety and performance.
            </p>
            
            <p>
              With a reputation built on trust, precision, and unwavering attention to detail, Centric MX continues 
              to be the go-to partner for general aviation maintenance in Northwest Florida. Our mission is to provide 
              aircraft owners with peace of mind, knowing their investment is in the hands of experienced professionals 
              who share their passion for aviation excellence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}